import $ from 'jquery';
export const API_HOST = 'gactivityapi.blancozone.com';
export const EVENT_HOST = 'gevents.blancozone.com';
export const AID = 'frxxyy';
export const PHONEMERGE = 'PHONE_MERGE';
export const TOKEN = 'TOKEN';
export const TELEPHONE = 'TELEPHONE';
const BASE_URL = `//${API_HOST}/activity/execute?name=${AID}&action=`;
const BASE_DATA = {
  phoneMerge: localStorage.getItem(PHONEMERGE),
  token: localStorage.getItem(TOKEN),
};
export const updateReserveData = (phoneMerge, token) => {
  localStorage.setItem(PHONEMERGE, phoneMerge);
  localStorage.setItem(TOKEN, token);
  BASE_DATA.phoneMerge = phoneMerge;
  BASE_DATA.token = token;
};
const URL = {
  reserveInfo: `${BASE_URL}reserveInfo`,
  reserve: `${BASE_URL}doReserve&cid=${window.cid}&scid=${window.scid}`,
  bag: `${BASE_URL}awardLog`,
  serverList: `${BASE_URL}listServer`,
  roleList: `${BASE_URL}getMobileGameRole`,
  bind: `${BASE_URL}bind`,
  base: `${BASE_URL}basic`,
  commit: `${BASE_URL}commit`,
  lottery: `${BASE_URL}lottery`,
};
const ajax = function ({ url, data, type, dataType }) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url,
      data: {
        params: JSON.stringify(data) || '',
      },
      type: type || 'get',
      jsonp: 'callback',
      dataType: dataType || 'jsonp',
      success: function (res) {
        resolve(res);
      },
      fail: function () {
        reject();
      },
    });
  });
};
export const getReserveInfo = () => {
  return ajax({ url: URL.reserveInfo });
};

export const reserve = data => {
  return ajax({
    url: URL.reserve,
    data,
  });
};

export const getBag = () => {
  return ajax({ url: URL.bag, data: BASE_DATA });
};

export const lottery = () => {
  return ajax({ url: URL.lottery, data: BASE_DATA });
};

export const commit = type => {
  return ajax({
    url: URL.commit,
    data: Object.assign(BASE_DATA, {
      type,
    }),
  });
};
export const getServerList = () => {
  return ajax({ url: URL.serverList });
};

export const getRoleList = sid => {
  return ajax({
    url: URL.roleList,
    data: {
      server_id: sid,
    },
  });
};
export const bindRole = data => {
  return ajax({
    url: URL.bind,
    data: data,
  });
};
export const getBase = () => {
  return ajax({
    url: URL.base,
    data: BASE_DATA,
  });
};
export const logout = () => {
  return ajax({
    url: URL.logout,
  });
};
